export default __webpack_public_path__ + "static/media/fp.addd8484.svg";